import React from 'react';

import { Link, IconButton, Stack, Typography, Box } from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

import { StatusIndicator } from 'scenes/Campaigns/components/shared';

const PromoCode = ({ value, row, colDef }) => {
  const { onCreate, onShowDetails } = colDef;

  const handleOpenCreateForm = () => {
    onCreate([row]);
  };

  const handleOpenDetails = () => {
    onShowDetails(value.id);
  };

  return value ? (
    <Stack
      direction={'row'}
      alignItems={'center'}
      sx={{ height: '100%', lineHeight: 'normal' }}
    >
      {value.status?.name ? (
        <StatusIndicator status={value.status.name} />
      ) : null}
      <Stack zeroMinWidth>
        <Typography variant={'inherit'} noWrap>
          <Link onClick={handleOpenDetails}>{value?.name}</Link>
        </Typography>
        <Typography
          variant={'caption'}
          sx={{
            fontSize: 10,
          }}
          noWrap
        >
          <DateRangeFormatter value={value.period} template={'LL'} />
        </Typography>
      </Stack>
    </Stack>
  ) : (
    <Box justifyContent={'center'} display={'flex'}>
      <IconButton
        add
        tooltip={'Add Promo Code'}
        onClick={handleOpenCreateForm}
      />
    </Box>
  );
};

export default PromoCode;
